// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__2NKAO","signatureButtonsRight":"ModalSign_signatureButtonsRight__3ZDKA"};